/* eslint-disable react/prop-types */
import React, { useContext } from 'react';

import Link from 'next/link';
import { HeaderContext } from '../../../contexts/headerContext';
import PageHeader from '../../shared/PageHeader';

function BreadCrumb({ type = 1, headerBreadCrumb, marginClass = '', showHeading = true }) {
  const { headerData } = useContext(HeaderContext);
  if (type === 1) {
    return (
      <div className={`font-medium sm:mb-0 pt-1
         hidden lg:block`}
      >
        <div className="header flex justify-between items-center">
          <PageHeader
            pageHeading={headerData.headerBreadCrumb}
            breadCrumb={(
              <span>
                <Link href="/home">Home </Link>
                /
                {' '}
                <span className="text-gray-700">{headerData.headerBreadCrumb}</span>
              </span>
        )}
        showHeading={showHeading}
          />
        </div>
      </div>
    );
  }
  return (

    <div className="header flex justify-between items-center">
      <PageHeader
        pageHeading={headerData.headerBreadCrumb}
        marginClass={marginClass}
        breadCrumb={(
          <span>
            <Link href="/home">Home </Link>
            /
            {' '}
            <span className="text-gray-700">{headerData.headerBreadCrumb || headerBreadCrumb}</span>
          </span>
        )}
        showHeading={showHeading}
      />
    </div>
  );
}

export default BreadCrumb;
